module.exports = "https://r.nearpod.com/assets/media/image/nearpod-slides-icon-42c75c13ec9f863284eb33bba608bcea.svg";